export class EventModel {
    website: string;
    path: string;
    error: string;
    stackTrace: string;
    userAgent: string;
    userId: string;
}